'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/Loader.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Loader = function (_BcReactComponent) {
  _inherits(Loader, _BcReactComponent);

  function Loader() {
    _classCallCheck(this, Loader);

    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
  }

  _createClass(Loader, [{
    key: 'renderMessage',
    value: function renderMessage() {
      if (this.props.message) {
        return _react2.default.createElement(
          'div',
          { className: 'loader-message' },
          this.props.message
        );
      }

      return _react2.default.createElement('noop', null);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-loader' },
        this.renderMessage(),
        _react2.default.createElement('img', { src: Loader.getSource(), alt: 'Loading' })
      );
    }
  }], [{
    key: 'getSource',
    value: function getSource() {
      // eslint-disable-next-line global-require
      return require('@bibliocommons/assets/images/preloader.grey.gif');
    }
  }]);

  return Loader;
}(_baseBcReactComponent2.default);

Loader.propTypes = {
  message: _react2.default.PropTypes.node
};

exports.default = Loader;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/loader/lib/components/Loader.js
// module id = 548
// module chunks = 3 4